import { IBscResponse } from "../interfaces/booking-supplier-cost";
import authBaseAxios from "../utils/api";
import qs from "qs";

export const BookingSupplierCostServices = {
  getAll: (params: any): Promise<IBscResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`booking-supplier-costs?${queryString}`);
  },
  getDropdownByType: (type: string) => {
    return authBaseAxios.get(`/booking-supplier-costs/dropdown-data?type=${type}`);
  },
  calculateBsc: (input: any): Promise<any> => {
    return authBaseAxios.post(`booking-supplier-costs/calculate`, input);
  },
  importClearDown: (formData: any) => {
    return authBaseAxios.post('/booking-supplier-costs/cleardown-esp', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
